module.exports = __webpack_public_path__ + "img/packagebanner.4b67cc78.jpg";